import type { DemandeRemboursementDTO } from '@/features/api/extranet/dto/Demande/DR'
import type { NaturesFichiersDemandeCallback } from '@/features/domaine/regles-akto/shared'
import { SousDispositif as SousDispositifAF } from '@/features/domaine/types/opco/Demande/AF'
import { SousDispositif as SousDispositifCPRO } from '@/features/domaine/types/opco/Demande/CPRO'
import { SousDispositifDRF } from '@/features/domaine/types/opco/Demande/CXPI'
import { SousDispositif as SousDispositifPROA } from '@/features/domaine/types/opco/Demande/PROA'

export const AttestationPresence = 'AttestationPresence' as const
// export const JustificatifMission = 'JustificatifMission' as const
export const JustificatifDelegation = 'JustificatifDelegation' as const
export const FactureCoutsPedagogiques = 'FactureCoutsPedagogiques' as const
export const JustificatifRemuneration = 'JustificatifRemuneration' as const
export const JustificatifFraisAnnexes = 'JustificatifFraisAnnexes' as const

export const getNaturesFichiersDR: NaturesFichiersDemandeCallback<DemandeRemboursementDTO> = (
  demande,
  _typeContext,
) => {
  let obligatoires: Set<string> = new Set([AttestationPresence])
  let facultatifs = new Set(['Autre'])
  let facultatifsDefaut: Set<string> = new Set([])

  // ERWAN : J'ai sourcé les docs sur les sous-dispositifs, car le dispositif du dossier est à "AUCUN"
  if (SousDispositifDRF.includes(demande.sousDispositif as SousDispositifDRF)) {
    const isCDII = demande.stagiaires?.some((s) => s.natureContrat === 'TravailTemporaireCdi')
    if (isCDII) {
      facultatifs.add(JustificatifDelegation)
    } else {
      obligatoires.add(JustificatifDelegation)
    }
    facultatifs.add(FactureCoutsPedagogiques)
    facultatifs.add(JustificatifRemuneration)
    facultatifs.add(JustificatifFraisAnnexes)
  } else if (['AfFpe', ...SousDispositifAF].includes(demande.sousDispositif)) {
    facultatifs.add(FactureCoutsPedagogiques)
  } else if (SousDispositifCPRO.includes(demande.sousDispositif as SousDispositifCPRO)) {
    facultatifs.add(FactureCoutsPedagogiques)
  } else if (SousDispositifPROA.includes(demande.sousDispositif as SousDispositifPROA)) {
    facultatifs.add(FactureCoutsPedagogiques)
  } else if (demande.sousDispositif === 'CAR') {
    obligatoires.add(FactureCoutsPedagogiques)
  }

  // PRT-1278 : simplification administrative
  if (demande.avecSimplificationAdministrative === 'Fichier') {
    facultatifsDefaut = new Set([...obligatoires, ...facultatifsDefaut])
    facultatifs = new Set([...facultatifsDefaut, ...facultatifs])
    obligatoires = new Set()
  }

  return {
    obligatoires: [...obligatoires],
    facultatifs: [...facultatifs],
    facultatifsDefaut: [...facultatifsDefaut],
    nombreFichiersMaximum: {},
    nombreFichiersMinimum: {},
  }
}
